import React from 'react';

import cloverSportLogo from '@/assets/images/clover-sport-logo.png';
import { Footer } from '@/layouts/Footer';

import { Alfalfa } from '@bypasslane/clover--web-lib-sprout-alfalfa';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './styles.scss';

import FlashBanner from '../features/mfa/components/FlashBanner';
import { withSentry } from '../instrument';

const HeroImage = () => (
  <div className="relative w-full h-full">
    <Link to="/">
      <img
        src={cloverSportLogo}
        alt="Clover Sport logo"
        className="absolute inset-0 object-cover w-50"
      />
    </Link>
  </div>
);

export default function AuthLayout({ children = null }) {
  return (
    <Alfalfa
      footerContent={<Footer />}
      classNames={{ page: 'h-100 w-100' }}
      heroImage={<HeroImage />}
    >
      <FlashBanner />
      {children}
    </Alfalfa>
  );
}

export function withAuthLayout(Component, config = {}) {
  let WrappedComponent = (props) => (
    <AuthLayout>
      <Component {...props} />
    </AuthLayout>
  );

  if (config.enableProfiler || config.enableErrorBoundary) {
    WrappedComponent = withSentry(WrappedComponent, config);
  }

  return WrappedComponent;
}

AuthLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
};
AuthLayout.displayName = 'AuthLayout';
withAuthLayout.propTypes = {
  Component: PropTypes.elementType.isRequired,
  config: PropTypes.object
};
withAuthLayout.displayName = 'withAuthLayout';
Footer.propTypes = {
  user: PropTypes.object
};
